import { render } from "./LessonProductOptionModal.vue?vue&type=template&id=5d836541"
import script from "./LessonProductOptionModal.vue?vue&type=script&lang=js"
export * from "./LessonProductOptionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__